import { TRACKERS } from "@/constants/Trackers";
import { Search } from "@/features/Search/Search";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

const searchSchema = z.object({
  patientId: z.string().optional(),
  patientFirstName: z.string().optional(),
  patientLastName: z.string().optional(),
  dob: z.string().optional(),
  visitId: z.string().optional(),
});

export const Route = createFileRoute("/search")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_SEARCH);
  },
});

function RouteComponent() {
  return <Search />;
}
